import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import styles from "./section-container.module.scss";
export function SectionContainer(t0) {
  const $ = _c(9);
  const {
    children,
    sectionTitle,
    header,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(styles.root, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== header || $[3] !== sectionTitle) {
    t2 = header ?? <div className={styles.defaultHeader} data-node-id="331:8523"><h2 className={styles.defaultTitle} data-node-id="331:8524">{sectionTitle}</h2></div>;
    $[2] = header;
    $[3] = sectionTitle;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children || $[6] !== t1 || $[7] !== t2) {
    t3 = <div className={t1}>{t2}{children}</div>;
    $[5] = children;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}